// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "tooltip-31l80";
export { _1 as "__esModule", _2 as "tooltip" }
export default { "__esModule": _1, "tooltip": _2 }
